import { combineReducers } from "redux";

import { typesFor } from "./types";

const rootReducer = combineReducers({
  worklist: createReducer("worklist")
});

export function createReducer(domain, domainInitialState) {
  const initialState = {
    displayingRows: 25,
    displayOptions: [25, 50, 75, 100],

    activePage: 1,

    startPage: null,
    endPage: null,

    hasNextPage: false,
    hasPrevPage: false,

    visiblePages: 5,
    totalRows: 0,
    ...domainInitialState
  };

  const types = typesFor(domain);

  const paginationReducer = (state = initialState, action) => {
    switch (action.type) {
      case types.CHANGE_PAGE:
        return { ...state, activePage: action.payload };
      case types.CHANGE_DISPLAYING:
        return { ...state, displayingRows: action.payload };
      case types.SET_TOTAL_ROWS:
        return { ...state, totalRows: action.payload };
      case types.SET_START_PAGE:
        return { ...state, startPage: action.payload };
      case types.SET_END_PAGE:
        return { ...state, endPage: action.payload };
      case types.HAS_NEXT_PAGE:
        return { ...state, hasNextPage: action.payload };
      case types.HAS_PREV_PAGE:
        return { ...state, hasPrevPage: action.payload };
      case types.RESET_PAGE:
        return { ...state, activePage: 1 };
      default:
        return state;
    }
  };

  return paginationReducer;
}

export default rootReducer;
